module.exports = __webpack_public_path__ + "media/ask/male-back-8cbd291a.svg";